export default function isIOSBrowser(navigatorInfo = window.navigator) {
  const userAgent = navigatorInfo.userAgent || "";
  return /iPad|iPhone|iPod/i.test(userAgent) ||
    (navigatorInfo.platform === "MacIntel" && navigatorInfo.maxTouchPoints > 1);
}
